import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../app/SliceUtils";

export const fetchStudentHistory = createAsyncThunk(
    '/api/history/student/studentId',
    ({ studentId, departmentId }, { rejectWithValue }) =>
        ApiFetch({
            endpoint: departmentId ?
                `api/history/student/${studentId}/${departmentId}` :
                `api/history/student/${studentId}`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const fetchStudentProgramHistory = createAsyncThunk(
    '/api/history/program/studentId/programId/departmentId',
    ({ studentId, programId, departmentId }, { rejectWithValue }) =>
        ApiFetch({
            endpoint: departmentId ?
                `api/history/program/${studentId}/${programId}/${departmentId}` :
                `api/history/program/${studentId}/${programId}`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const historySlice = createSlice({
    name: 'history',
    initialState: {
        studentHistory: { data: null, status: null },
        studentProgramHistory: { data: null, status: null },
    },
    reducers: {
        resetHistory: (state) => {
            ResetSliceState(state);
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchStudentHistory, 'studentHistory');
        CreateAsyncStatusHandler(builder, fetchStudentProgramHistory, 'studentProgramHistory');
    }
});

export const { resetHistory } = historySlice.actions;

export default historySlice.reducer;